/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_HeaderInputs */

const en_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

const fr_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriete`)
};

const de_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigentum`)
};

const it_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietà`)
};

const ru_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свойство`)
};

const es_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad`)
};

const zh_cn2_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`财产`)
};

const ja_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`財産`)
};

const hi_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपत्ति`)
};

const pt_pt2_explorer_info_property_header = /** @type {(inputs: Explorer_Info_Property_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Explorer_Info_Property_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_header = /** @type {((inputs?: Explorer_Info_Property_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_header(inputs)
	if (locale === "de") return de_explorer_info_property_header(inputs)
	if (locale === "it") return it_explorer_info_property_header(inputs)
	if (locale === "ru") return ru_explorer_info_property_header(inputs)
	if (locale === "es") return es_explorer_info_property_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_header(inputs)
	if (locale === "ja") return ja_explorer_info_property_header(inputs)
	if (locale === "hi") return hi_explorer_info_property_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_header(inputs)
	return en_explorer_info_property_header(inputs)
});